// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JVDC","left":"styles_left__iUFyx","desktopActions":"styles_desktopActions__3jrux","title":"styles_title__vTAaw"};